import { MetaData } from "../interfaces/config/metaData";

/**
 * Default description used for meta data.
 *
 * @constant {string}
 */
const description =
  "Genio EHR is a modern electronic health record system designed for healthcare professionals to manage patient data, clinical workflows, and medical insights efficiently and securely.";

/**
 * Metadata for different pages in the application.
 *
 * @type {MetaData}
 */
const metaData: MetaData = {
  home: {
    title: "Genio EHR | Modern Electronic Health Record System for Healthcare Professionals",
    description,
  },
  notFound: {
    title: "Genio EHR | Not Found",
    description,
  },
};

export default metaData;
